import React from 'react';
import { AiOutlineShoppingCart, AiOutlineHeart } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { Global } from '../../Variables/Global';

const NewArrival = (props) => {
    const {
        product,
        WishListItems = [],
        HandleAddToWishList,
        HandleRemoveFromWishList
    } = props;

    // 🛑 HARD GUARD — prevents crash
    if (!product || !product.DefaultVariation) return null;

    const { DefaultVariation } = product;
    const productUrl =
        `/DetailedProduct/${product.ProductName.replace(/ /g, "-")}` +
        `/${product.ProductId}/${DefaultVariation.ProductVariationId}`;

    const image1 = Global.PHOTO_URL + DefaultVariation.Image1;
    const image2 = DefaultVariation.Image2
        ? Global.PHOTO_URL + DefaultVariation.Image2
        : null;

    const isInWishlist = WishListItems.some(
        obj => obj.ProductId === product.ProductId
    );

    return (
        <div className="gf-product tab-slider-sub-product">
            <div className="image">
                {!props.product.InStock && (
                    <span className="out-of-stock-badge">
                        Out of Stock
                    </span>
                )}
                <Link to={productUrl}>
                    <img
                        src={image1}
                        alt={product.ProductName}
                        onMouseOver={image2 ? e => (e.currentTarget.src = image2) : undefined}
                        onMouseOut={image2 ? e => (e.currentTarget.src = image1) : undefined}
                    />
                </Link>

                <div className="product-hover-icons">
                    <Link to={productUrl} data-tooltip="Add to cart">
                        <AiOutlineShoppingCart className="mb-1" color="white" />
                    </Link>

                    {
                        props.WishListItems.find(obj => obj.ProductId === props.product.ProductId) ? (
                            <a data-tooltip="Remove From wishlist" onClick={() => props.HandleRemoveFromWishList(props.product.ProductId)}>
                                <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                            </a>
                        ) : (
                            <a data-tooltip="Add to wishlist" onClick={() => props.HandleAddToWishList(props.product.ProductId, props.product.DefaultVariation.ProductVariationId)}>
                                <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                            </a>
                        )
                    }
                </div>
            </div>

            <div className="product-content">
                <h3 className="product-title">
                    <Link className="RemUnderline" to={productUrl}>
                        {product.ProductName}
                    </Link>
                </h3>

                <div className="price-box">
                    {DefaultVariation.SalePrice === 0 ? (
                        <span className="discounted-price RemUnderline">
                            AED{DefaultVariation.RegularPrice}
                        </span>
                    ) : (
                        <>
                            <span className="main-price RemUnderline">
                                AED{DefaultVariation.SalePrice}
                            </span>
                            <span className="discounted-price RemUnderline">
                                AED{DefaultVariation.RegularPrice}
                            </span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewArrival;
